import React from 'react';

import { ReactComponent as CloseIcon } from '../images/x.svg';
import { ReactComponent as EditIcon } from '../images/edit.svg';


const Widget = ({editAdmin, deleteAdmin}) => {
  return (
    <div style={{display: 'flex',
                 alignItems: 'center',
                 justifyContent: 'center',
                 cursor: 'pointer',
                 gap: '20px',
                }}>
      <EditIcon
        style={{width: '20px',
                height: '20px',
                fill: 'white',
                cursor: 'pointer',
               }}
        onClick={() => editAdmin() }
      />
      <CloseIcon
        style={{width: '20px',
                height: '20px',
                fill: 'red',
                cursor: 'pointer',
               }}
        onClick={() => deleteAdmin() }
      />
    </div>
  );
}

export default Widget;
